const initialState = {
  list: {
    isLoading: false,
    error: '',
    paginationOptions: {
      page: 1,
      size: 9,
      ordering: 'name',
      archived: false,
    },
    data: {
      items: [],
      count: 0,
    },
  },
  add: {
    isLoading: false,
    error: '',
  },
  download: {
    isLoading: false,
    error: '',
  },
  update: {
    isLoading: false,
    error: '',
  },
  delete: {
    data: {},
    isLoading: false,
    error: '',
  },
  overrideAllXpackIntents: {
    isLoading: false,
    error: '',
  },
  disableAllXpackIntents: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
